import { Link } from 'react-router-dom';
import { Box, Button } from '@capitalise/ui-design-system';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from 'modules/Business/hooks/useMediaQuery';

const NavbarLink = ({ to, label, icon, chip }) => {
  const { isSm } = useMediaQuery();

  const linkMatchUrl = (to) => {
    const pathname = window.location.pathname;
    return pathname.endsWith(to);
  };

  const isActive = linkMatchUrl(to);

  return (
    <Box
      display="flex"
      px="xsmall"
      borderRight={isActive && '4px solid'}
      borderColor={isActive ? 'green-500' : 'grey-900'}
    >
      <Link to={to}>
        <Box display="flex">
          <Button
            variant="text"
            baseColor={isActive ? 'green-500' : 'grey-900'}
            leftIcon={icon}
            data-testid={`link-${label.toLowerCase().replaceAll(' ', '-')}`}
          >
            {label}
          </Button>
        </Box>
      </Link>
      <Box cursor="pointer">{chip}</Box>
    </Box>
  );
};

NavbarLink.propTypes = {
  to: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.node,
  chip: PropTypes.node,
};

export default memo(NavbarLink);
